<app-header></app-header>
<section class="container-xxl">
    <div class="breadcrumb-area">
        <nav aria-label="breadcrumb mb-0">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a class="screen-reader" [attr.title]="language=='English'?'Home':'होम'" routerLink="/">{{ 'Home' | translate }}</a></li>
                <li class="breadcrumb-item"><a class="screen-reader" [attr.title]="language=='English'?'Blogs':'ब्लॉग'" routerLink="/blogs">{{ 'Blogs' | translate }}</a></li>
                <li class="breadcrumb-item active screen-reader">{{ 'BlogDetails' | translate }}</li>
            </ol>
        </nav>
    </div> 
    <div class="inner-page-sidedetails">
        <div id="section-New"></div>
        <div class="inner-banner-image"> 
            <div class="image-area">
                <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
            </div>
        </div>
        <div class="details">
            <div class="title">
                <h2 class="screen-reader">{{ 'BlogDetails' | translate }}</h2>
            </div>
            <div class="description">
                <div class="news mb-3">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="info-box">
                                <div class="news-section">

                                    <!-- left section -->

                                    <div class="card h-100">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-xxl-8 col-xl-8 col-lg-8 col-md-12">
                                                    <div class="news-full-sec">
                                                        <h2 class="screen-reader">{{ encDec.decodeHtml(language=='English'?blogsDtl.title:blogsDtl.titleInHindi) }}</h2>
                                                        <div
                                                            class="list-inline-item d-flex mb-3 mt-2 custom-border-bottom pb-3">
                                                            <div class="stip-num screen-reader"> <span><i
                                                                        class="bi bi-calendar3 me-1"></i>
                                                                        {{ getMonth(blogsDtl.publishDate  | date: 'MMMM') }}
                                                                        {{ blogsDtl.publishDate  | date: 'd, y' }}
                                                                </span> </div>
                                                        </div>
                                                        <ng-container>
                                                            <div class="news-photo">
                                                                <img class="img-fluid screen-reader" [src]="backend_url+'storage/app/uploads/'+blogsDtl.blogBannerImage" title="{{encDec.decodeHtml(blogsDtl.title)}}" alt="{{encDec.decodeHtml(language=='English'?blogsDtl.title:blogsDtl.titleInHindi)}}">
                                                            </div>
                                                        </ng-container>
                                                        <p class="screen-reader font-adjust" [innerHTML]="encDec.decodeHtml(language=='English'?blogsDtl.description:blogsDtl.descriptionInHindi)"></p>
                                                    </div>
                                                    <div class="fp_footer">
                                                        <div class="mt-3">
                                                            <ul class="pdf-news">
                                                                <li *ngIf="blogsDtl?.uploadDocument_details?.fileSize!==''">
                                                                    <a target="_blank" class="screen-reader" href="javascript:void(0);"
                                                                        title="The pdf file Open in New Window">
                                                                        <!-- Test Link 1 -->
                                                                    </a>
                                                                    <div class="opening-date">
                                                                        <span class="d-block">
                                                                            <a target="_blank"
                                                                             [href]="backend_url+'storage/app/uploads/'+blogsDtl.uploadDocument" title="{{encDec.decodeHtml(blogsDtl.title)}}"
                                                                            [download]="blogsDtl.uploadDocument"
                                                                                class="text-success screen-reader"><span class="me-2">
                                                                                    <i class="bi bi-download me-1"></i>
                                                                                    {{ 'Download' | translate }}</span>
                                                                                    ({{ blogsDtl?.uploadDocument_details?.fileSize }})
                                                                                    <span style="text-transform: uppercase;" *ngIf="checkFileType(blogsDtl)!==false" [innerHtml]="checkFileType(blogsDtl).file"></span>
                                                                                    {{blogsDtl.dtmCreatedOn | date:'MMM d, y'}}
                                                                                </a>
                                                                        </span>
                                                                        <span class="labels text-muted screen-reader"></span>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>


                                                <!-- left section -->


                                                <!-- right section -->
                        <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-12 custom-border-start">
                            <div
                                class="d-flex custom-border-bottom align-items-center justify-content-between">
                                <div class="flex-grow-1 hed-news">
                                    <h5 class="screen-reader">{{ 'LATESTBLOGS' | translate }}</h5>
                                </div>
                                <div class="news-list-icon"><i class="bi bi-newspaper fs-4 "></i></div>
                            </div>
                            
                            <div class="news-scroll mt-3">


                                <div class="section-content custom-border-bottom px-2 py-2 {{ getclass(item.id) }}" *ngFor="let item of blogsList | paginate: { id:'pg1',itemsPerPage: limit, currentPage: currentPage,totalItems: totalRecords};">
                                    <div class="row">
                                        <div
                                            class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-5">
                                            <div class="news-image-area">
                                                <img class="img-fluid screen-reader" [src]="backend_url+'storage/app/uploads/'+item.blogImage" title="{{encDec.decodeHtml(language=='English'?item.title:item.titleInHindi)}}" alt="{{encDec.decodeHtml(language=='English'?item.title:item.titleInHindi)}}">
                                            </div>
                                        </div>
                                        <div
                                            class="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-8 col-7">
                                            <div class="news-description-area py-2 ">
                                                <div class="date-area font-adjust">
                                                    <p><span class="text-muted screen-reader"><i
                                                                class="bi bi-calendar me-1"></i>
                                                                {{ getMonth(item.publishDate  | date: 'MMMM') }}
                                                                        {{ item.publishDate  | date: 'd, y' }}
</span>
                                                    </p>
                                                </div>
                                                <div class="heading-area font-adjust">
                                                    <div>
                                                        <div>
                                                            <a [attr.title]="language=='English'?'blog title':'ब्लॉग का शीर्षक'" class="screen-reader" (click)="viewDetails(item.id)" href="javascript:void(0);">{{encDec.decodeHtml(language=='English'?item.title:item.titleInHindi) }}</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <pagination-controls id="pg1" class="text-center screen-reader m-2" (pageChange)="pageChanged($event)" *ngIf="totalRecords > 10"></pagination-controls>
                            </div>
                        </div>
                                            </div>
                                        </div>
                                        <!-- right section -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-clients></app-clients>

<app-footer></app-footer>